import {
  canHostRoom,
  isBackstage,
  isClosing,
  isConference,
  isLive,
  isRecordingEnabled,
  isStream,
} from "@circle-react/helpers/liveStreamRoomHelpers";
import type { Room } from "@circle-react/types/Live/Room";
import { useProviderHlsState } from "../../hooks/provider";

export const useRoomStatus = (room: Room) => {
  const { live_at: liveAt } = room;
  const { isHlsRunning, isRecording } = useProviderHlsState();
  const isInitializing =
    !isHlsRunning &&
    isLive(room) &&
    !isClosing(room) &&
    (!isConference(room) || isRecordingEnabled(room));

  return {
    isStream: isStream(room),
    isInitializing,
    isLive: (isLive(room) || isClosing(room)) && isHlsRunning,
    isClosing: isClosing(room),
    liveAt,
    isBackstage: isBackstage(room) && canHostRoom(room),
    isRecording: isRecording && !isClosing(room),
  };
};
